module.exports = __webpack_public_path__ + "997f6b1819184c54248de33c81b7bb0c.woff";